import React from 'react';

export const REACTIONS = [
    <img id={0} src="./images/emoji-message/icon-like@2x.png" />,
    <img id={1} src="./images/emoji-message/icon-love@2x.png" />,
    <img id={2} src="./images/emoji-message/icon-haha@2x.png" />,
    <img id={3} src="./images/emoji-message/icon-yay@2x.png" />,
    <img id={4} src="./images/emoji-message/icon-angry@2x.png" />,
    <img id={5} src="./images/emoji-message/icon-sad@2x.png" />,
] 

// 0: "REACTIONCODE_LIKE",
// 1: "REACTIONCODE_LOVE",
// 2: "REACTIONCODE_HAHA",
// 3: "REACTIONCODE_YAY",
// 4: "REACTIONCODE_WOW",
// 5: "REACTIONCODE_SAD",
// 6: "REACTIONCODE_ANGRY",


